/* global $ */

import { throttleDomAfterAsync } from '../helpers/throttle';

// class recording if browser has ever been resized (used to immediately finish all animations)
$(window).one('resize', () => $('html').addClass('was-resized'));

// dynamically recalculates the true viewport height, taking mobile url bars into account.
const setVHUnitDesktop = () => {
	if (window.innerWidth > 580) {
		window.setVHUnit();
	}
};

window.addEventListener('resize', throttleDomAfterAsync(setVHUnitDesktop, 50));
window.addEventListener(
	'orientationchange',
	throttleDomAfterAsync(window.setVHUnit, 200)
);
